import React from 'react';
import { routesConfig } from '@src/core/routes';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ArcGlobalLoading } from '@src/core/widgets';
import { FlightProvider } from '@src/features/order/provider';

const FleetFeature = React.lazy(() => import('@src/features/fleet'));
const AnalyticsFeature = React.lazy(() => import('@src/features/analytics'));
const ProfileFeature = React.lazy(() => import('@src/features/profile'));

const Analyst: React.FC = () => {
  return (
    <FlightProvider>
      <React.Suspense fallback={<ArcGlobalLoading />}>
        <Routes>
          <Route path="/analytics/*" element={<AnalyticsFeature />} />
          <Route
            path="/fleet/*"
            element={<FleetFeature limitedFleetAccess />}
          />
          <Route path="/profile/*" element={<ProfileFeature />} />

          <Route path="*" element={<Navigate to={routesConfig.analytics} />} />
        </Routes>
      </React.Suspense>
    </FlightProvider>
  );
};

export default Analyst;
